<script lang="ts" setup>
defineEmits(["showNotifications"]);

const userStore = useUserStore();
const showNotificationsMenu = defineModel("showNotifications", {
  type: Boolean,
});
</script>

<template>
  <div
    class="md:hidden p-2 border-b bg-[#5b566b] border-secondary-500"
    @click="showNotificationsMenu = true">
    <div class="p-2 flex gap-6 items-center font-semibold text-neutral-200">
      <NuxtIcon name="mdi:bell" class="w-8 h-8 text-neutral-200" />
      <div class="w-[65%]">
        <p class="text-xl md:text-base font-bold md:font-normal">
          {{ $t("main.headerNotifications.notifications") }}
        </p>
      </div>
      <div class="w-[15%] pr-2">
        <div
          v-if="userStore.notifications.unread > 0"
          class="h-9 bg-primary-500 rounded-full flex items-center justify-center min-w-10 max-w-12">
          <span class="text-primary-600 text-[1rem] text-center mr-[0.1rem]">
            {{
              userStore.notifications.unread > 99
                ? "99+"
                : userStore.notifications.unread
            }}</span
          >
        </div>
      </div>
    </div>
  </div>
</template>
